module.exports = __webpack_public_path__ + "static/media/image13.dabd32e3.png";